import Vue from 'vue';
import DatesFormat from '@/util/classes/datesFormat';
const dateFormat: DatesFormat = new DatesFormat();

export const formatDate = (date: string): string => {
  return dateFormat.formatDate(date);
};

export const dateTime = (date: string): string => {
  return dateFormat.formatDateTime(date);
};

export const moneyFormat = (money: number): string => {
  const formatter = new Intl.NumberFormat('en-US',
    { style: 'currency', currency: 'USD', }
  );
  return formatter.format(money);
};

Vue.filter('money', function (money: number) {
  return moneyFormat(money);
});

Vue.filter('brithdate', function (date: string) {
  return dateFormat.formatBrithdate(date);
});

Vue.filter('date', function (date: string) {
  return dateFormat.formatDate(date);
});

Vue.filter('dateTime', dateTime);
Vue.filter('moneyCents', function (money: number) {
  money = money / 100;
  const formatter = new Intl.NumberFormat('en-US',
    { style: 'currency', currency: 'USD', }
  );
  return formatter.format(money);
});

